import { render, staticRenderFns } from "./InspectionInfo.vue?vue&type=template&id=26997c98&scoped=true&"
import script from "./InspectionInfo.vue?vue&type=script&lang=js&"
export * from "./InspectionInfo.vue?vue&type=script&lang=js&"
import style0 from "./InspectionInfo.vue?vue&type=style&index=0&id=26997c98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26997c98",
  null
  
)

export default component.exports